export default __webpack_public_path__ + "static/media/profile-picture.ad2bc97b.jpg";